import { getFromStorage } from "../utils/Helper";
import { StorageConstant } from "./Constants";

const EnglishLanguage = {
  HOME:'Home',
  VIEW: 'View',
  VIEW_ALL: 'View all',
  PRE_PRODUCT_PRICE: 'Unit Price',
  REQUIRED_LOACTION: 'Please select loaction type',
  RESIDENTIAL: 'Residential',
  LABORAL: 'Commercial',
  LOACTION_TYPE: 'Type Of Domicile',
  AWB_NUMBER: 'AWB Number',
  WAYBILLNUMBER: 'Waybill Number',
  SHIPPINSCompany: 'Shipping Company',
  TRAKING_URL: 'Tracking Url',
  TRAKING_NUMBER: 'Tracking Number',
  SHPPING_DEATILS: "Shipping Details",
  CHANGE_ADDRESS_DES: 'If you change the address then current quotation will not be valid and the request will be sent again to the admin.',
  CHANGE_ADDRESS: 'Change Address',
  VALID_PHONE_NUMBER: "Phone number must be at last 7 numbers.",
  PHONE_MAX_CHAR: "Phone number cannot exceed more than 15 numbers.",
  PHONE_NUMBER_VALID: "Entered mobile number is invalid, please try again.",
  VALID_PHONE: 'Please enter valid phone number',
  EMAIL_ADDRESS: 'Please enter valid email address.',
  EMAIL_MAX: 'Email cannot exceed more than 150 characters',
  EMAIL_MIN: 'Email must be at least 3 characters',
  PLEASE_ENTER_Email: 'Please enter your Email',
  NAME_MAX: 'Name cannot exceed more than 25 characters',
  NAME_MIN: 'Name must be at least 3 characters',
  PLEASE_ENTER_NAME: 'Please enter your name',
  STREET_LINE_OTHER: "Street line cannot contain consecutive spaces",
  STREET_LINE_CONTACT_DES_MAX: 'street line cannot exceed more than 250 characters',
  STREET_LINE_DES_MIN: 'street line must be at least 3 characters',
  STREET_LINE: 'Please enter your street line',
  SELECT_EXCEL: "Please select excel file",
  ENTER_PASSWORD: "Please enter password",
  Emojis: 'Emojis and special characters not allowed',
  DES_LINE: 'description line cannot contain consecutive spaces',
  CONTACT_DES_MAX: 'description cannot exceed more than 250 characters',
  DES_MIN: 'description must be at least 3 characters',
  ENTER_DESC: "Please enter your description",
  PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: "New password and confirm password must be same",

  CONFIRM_PASSWORD_MIN_CHAR: "Confirm password must have at least 8 characters.",
  CONFIRM_PASSWORD_MAX_CHAR: "Confirm Password should not exceed 16 characters",
  NEW_PASSWORD_REQUIRED: "Please enter new password.",
  NEW_PASSWORD_MIN_CHAR: "New password must have at least 8 characters.",
  NEW_PASSWORD_MAX_CHAR: "New Password should not exceed 16 characters",

  CONFIRM_NEW_PASSWORD_REQUIRED: "Please enter confirm password.",
  CONFIRM_NEW_PASSWORD_MIN_CHAR: "Re-enter password must have at least 8 characters.",
  CONFIRM_NEW_PASSWORD_MAX_CHAR: "Re-enter Password should not exceed 16 characters.",
  // PASSWORD_CPWD_NOT_MATCHED: "Entered password doesn't match. please try again",
  PASSWORD_CPWD_NOT_MATCHED: "New password and Confirm password does not match.",
  PASSWORD_OLD_NOT_SAME: "You have already use this password before, please set another password",


  NEW_OLD_PASSWORD_SAME: 'New password cannot be  same as the old password',
  PASSWORD_MATCH: "Password should be between 8 to 15 characters and should contain atleat one uppercase, one lowercase, one number and one special character.",
  PASSWORD_VALID: "Password must contain alphanumeric characters that includes atleast 1 upper case character and 1 special character.",
  PASSWORD_UPPER_CASE: "Password must contain alphanumeric characters that includes atleast 1 upper case character and 1 special character.",
  PASSWORD_SPECIAL_CASE: "Password must contain alphanumeric characters that includes atleast 1 uppercase, 1 lowercase and 1 special character.",
  PASSWORD_NUMBER_CASE: "Password must contain alphanumeric characters that includes atleast 1 upper case character and 1 special character.",

  PASSWORD_REQUIRED: "Please enter password.",
  CONFIRM_PASSWORD_REQUIRED: "Please enter confirm  password.",
  NO_SPACE_ALLOWED: "No space allowed.",
  OLD_PASSWORD_REQUIRED: "Please enter old password.",
  OLD_PASSWORD_MIN_CHAR: "Old password must have at least 8 characters.",
  OLD_PASSWORD_MAX_CHAR: "Old Password should not exceed 16 characters.",
  EXCEED: "cannot exceed more than",
  MAX: 'must be at least',
  PLEASE_SELECT: 'Please select your',
  PLEASE_ENTER: 'Please enter your',
  VERFIY_EMAIL: 'Please verfiy your email',
  OTHER_MAX: "Other brand name cannot exceed 50 characters",
  OTHER_MIN: "Other brand name minimum 1 words",
  OTHER_BRAND_REQUIRED: "Other brand name is required",
  MODAL_MAX: "Model number cannot exceed 50 characters",
  SER_MAX: "Serial number cannot exceed 50 characters",
  DES_MAX: 'Description must be at most 250 characters',
  QUNTITY_NUMBER: "Please enter only number",
  QUNTITY_MAX: 'Quantity cannot exceed 1000000 ',
  QUNTITY_MIN: 'Quantity must be at least 1',
  QUNITYTY_REQUIRED: "Quantity is required",
  PART_NUMBER_MAX: 'Part Number cannot exceed 50 characters',
  PART_NUMBER_MIN: 'Part Number must be at least 1 character',
  PART_NUMBER_REQUIRED: 'Part Number is required',
  BRAND_NAME_REQUIRD: 'Brand Name is required',
  BRAND_NAME_ALREDY: 'Brand name already exists.',
  PLEASE_SELECT_SHIPPING_TYPE: 'Please select shipping method',
  PLEASE_SELECR_DELIVER_ADDRESS: 'Please select delivery address',
  PLEASE_SELECT_TYPE: 'Please select a type',
  CUSTOMER_PURCHASED: "Customers have also purchased",
  PRODUCTLISTING: "Product Listing",
  CONTACTUS: "Contact Us",
  PRODUCTSUGGESTIOND: "Product Suggestions",
  REQUESTQUOTES: "Request a Quote",
  ABOUTUS: 'About Us',
  TESTIMONIAL: "Testimonials",
  CLIENTREVIEW: 'What happy clients say about us?',
  PRIACYPOLICY: "Privacy Policy",
  TERMS: 'Terms & Conditions',
  COPYRIGHT: "© 2025-2026 Quote n Buy. All rights reserved.",
  FAQS: "FAQ'S",
  LOGIN: "Login",
  LOGOUT: "Logout",
  VIEWPROFILE: "View Profile",
  MYORDER: "My Orders",
  MYADDRESS: "My Addresses",
  MYOUESTION: 'My Quotes',
  SETTING: 'Settings',
  CHANGEPASSWORD: "Change Password",
  OLD_PASSOWRD: 'Old Password',
  NOTIFIACTION: 'Notification Setting',
  DELETEACCOUNT: "Delete Account",
  QUOTATIONFORM: 'Manual Entry',
  REQUESTVIA: 'Request via',
  BULKREQUEST: "Bulk Request via",
  EXCEL: 'Bulk Upload',
  COUNTINUE: "Continue",
  DELIVERYADDRESS: 'Select Delivery Address',
  SHIPPINGMETHOD: 'Select Shipping Method',
  NEWADDRES: "ADD NEW ADDRESS",
  UPDATEADDRES: "UPDATE ADDRESS",
  NEXT: "Next",
  BRANDNAME: "Brand",
  SELECTBRAND: 'Select brand',
  PARTNAME: 'Part N°',
  ENTER: 'Enter',
  QUANTITY: 'Quantity',
  EDITQUANTITY: 'Confirm Change',
  Description: 'Description',
  DESCIPTIONDETAILS: 'Write a detailed description',
  SERIALNUMBER: 'Serial N°',
  MODELNUMBER: 'Model ',
  UPLOADMEDIA: 'Photo or Video',
  ONEBYONE: 'One photo and one video',
  TWOBYTWO: 'Two photos',
  Photo: 'Photo',
  Video: 'Video',
  REMOVE: 'Remove',
  ADDMORE: 'Add New Item',
  SUBMIT: "Submit",
  EXCLSUBMIT: "Request Quote",
  REQUESTQUOTE: 'Request Quote',
  Download: 'Download',
  TEMPLATE: 'Excel Template',
  UploadExcel: 'Upload Excel',
  MYQUOTATIONS: 'My Quotations',
  PROFILE: 'Profile',
  QUOTATIONSLIST: 'Quotes',
  Filter: 'Filter',
  Reset: 'Reset',
  ALL: 'All',
  PENDING: 'Pending',
  Progress: 'In Process',
  APPROVED: 'Approved',
  REJECT: 'Rejected',
  SNO: 'S. No',
  QUOTATIONID: 'Quote Id',
  DATE: 'Date',
  STATUS: 'Status',
  SHIPPING: 'Shipping',
  PRICE: 'Price',
  OTHER: 'Other',
  CHARGES: 'Charges',
  TAX: 'Tax',
  AMOUNT: "Amount",
  NET: "Net",
  TOTAL: 'Total',
  ACTION: "Action",
  DELADDRESS: 'Delivery address',
  SHIPINNG: 'Shipping method',
  QDATE: 'Quotation Date',
  ORDERLIST: 'Order List',
  INTRANSIT: 'In Transit',
  DELIVERD: 'Delivered',
  CANVELLED: 'Cancelled',
  ORDERID: 'Order ID',
  PAYMENTSTATUS: 'Payment',
  DELIVERYSTATUS: 'Status',
  ORRDERDELIVERYADDRESS: 'Delivery Address',
  PROVIDEDQUOTATION: 'Quotation details',
  TOTALPRODUCTAMOUNT: 'Total Product Price',
  TOTALSHIIPNGAMOUNT: 'Shipping Price',
  TOTALTAX: 'Total Tax',
  GRANDTOTAL: 'Grand Total',
  CONVERTINPISO: 'Convert price in euro',
  NOTIFACTION: "Notifications",
  CHAT: "Chat",
  ADDMOREPRODUCT: "Add Another Item",
  DATANOTFOUND: 'Data Not Found',
  MORE: "More",
  PLEASE_ENTER_QUNTITY: "Please enter any product quantity",
  MY_PROFILE: "My Profile",
  NAME: "Name",
  EMAIL_ID: "Email ID ",
  PHONE_NUMBER: "Phone Number",
  UPDATE_PROFILE: "Update Profile",
  ENTER_FULL_NAME: "Enter Full Name",
  ENTER_EMAIL_ID: "Enter Email ID",
  SELETE_ADDRESS: "Select Address",
  STREE_LINE: "Street Line",
  ENTER_STREE_LINE: "Enter street line",
  APRATMENT: "Apartment",
  ENTER_APARTMENT: "Enter apartment",
  STATE: "State",
  ENTER_STATE: "Enter state",
  CITY: "City",
  ENTER_CITY: "Enter city",
  ZIP_CODE: "Zip Code",
  ENTER_ZIP_CODE: "Enter zip code",
  Contact_Us: "Contact Us",
  MESSAGE: "Message",
  SEND: "Send",
  SHIPPINGTYPE: "Shipping Type",
  PERPIUCESPRICE: "Per Piece Price",
  SHIPPINGPRICE: 'Shipping Price',
  TOTAL_SHPPINGH: 'Shipping Price',
  TOTAL_PRODUCT_PRICE: "Total Product Price",
  Reject: 'Reject',
  Approve: 'Approve',
  PRODUCT_HISTORY: 'Product History',
  PRODUCT_REVISON_HISTORY: "Product Revision History",
  LATEST_REVISION: 'Latest Revision',
  REVISION: 'Revision',
  ORIGNAL_REQUEST: 'Original Request',
  SHIPPING_DETAILS: "Shipping details",
  FROM: 'From',
  TO: "To",
  MESSAGEDATA: 'Search by quote Id',
  DATETYPE: "MM/DD/YYYY",
  VIEW_HISTORY: 'View History',
  PAID: 'Paid',
  PRICE_BRACKDOWN: 'Price Breakdown',
  ARE_YOU_SURE: 'Are you sure',
  YOU_WANT_TO_LOGUT: 'Are you sure you want to logout ?',
  YOU_WANT_TO_DELETE: 'Are you sure you want to delete your account ?',
  YOU_WANT_TO_DELETE_Address: 'Are you sure you want to delete your address ?',


  NO: 'No',
  YES: 'Yes',
  DELETE_ACCOUNT: 'Delete Account',
  PASSWORD: 'Password',
  CHECKOUT: 'Checkout',
  MOBILE: 'Mobile',
  ADDRESS: 'Address',
  EDIT: 'Edit',
  TOTAL_TAX_AMOUNT: 'Total Tax Amount',
  OTHER_CARGERS: 'Other Charges',
  NET_ORDER_AMOUNT: 'Net Order Amount',
  PAYMENT_MATHOD: 'Payment Method',
  ONLINE: 'Online',
  OFFLIE: 'Wire Transfer',
  PLACE_ORDER: 'Proceed with Payment',
  SELETE_PAYMENT_ERROR: 'Please select payment Method',
  Successful: 'Successful',
  ORDER_LINE_ONE: 'Your order has been successfully placed',
  ORDER_LINE_SEC: 'Your order is in process, this is not an invoice: An email has been sent with the information to make the payment via wire transfer. Once we receive the funds we will proceed with your order .',
  GO_TO_HOME: 'Go to Home',
  ORDER_CANCEL: 'Order Cancel',
  ORDER_CANCEL_MESSAGE: 'The request will be sent to the admin, if admin approves then only the cancellation will happen.',
  CANCEL: 'Cancel',
  ORDER_CANCEL_TITAL: 'Order Cancel Reason',
  REASON: 'Reason',
  Edit_Quantity: 'Edit Quantity',
  REMOVE_PRODUCT: 'Remove',
  EDIT_Q_MESSAGE: 'If you edit the quantity, a request will be sent to the admin for approval. The prices and quantity will only be updated if the admin accepts the change. If the request is rejected, the quantity and price will remain unchanged. Do you still want to proceed with editing the quantity?',
  DELETE_TITEL: 'Delete Product',
  PRODUCT_DELETE_MESSAGE: 'If you remove the products, a request will be sent to the admin for approval. The product will only be removed if the admin approves the request. If the request is rejected, the product will remain unchanged. Do you still want to proceed with removing  product',
  OTHER_BRAND_NAME: 'Other Brand Name',
  BRAND_NAME: 'Brand Name',
  REJECT_QUTO: "you want to reject this quotation ?",
  ORDER_FILLTER_INPUT: "Search by order Id ..",
  NEW_PASSWORD: 'New Password',
  CONFIRMA_PASSWORD: 'Confirm New Password',
  INSTRUCTIONS: 'Instructions for delivery (Optional)',
  ENTER_INSTRUCTIONS: "Enter instructions for delivery",
  PHOTOS_VIDEO: 'Photo or Video',
  UPLOAD: 'Upload Files',
  DOWNLOAD_PDF: 'Download Pdf',
  OTHER_BRAND: 'Other Brand',
  WRITE: 'Write',
  EDIT_QUANTITY: 'Edit Quantity',
  SEND_UPDATE_REQUEST: 'Send Updated Quantity',
  EXCHANGE: 'Exchange',
  HISTORY: 'History',
  ENTER_TIME_QUNTITY: 'Please enter quantity',
  ENTER_TIME_QUNTITY_NUMBER: 'Please enter only number',
  DOWNLADAPP: 'Download App',
  LETS_GO: 'Let’s go!',
  ORDER_QTY: 'Qty',
  DAYS: 'DAYS',
  BRAND: 'Brand',
  Item_Name: 'Item Name',
  UNIT: 'Unit',
  EXTED_PRICE: 'Extended Price',
  Charges_reason: 'Charges reason',
  SPANISH: 'Español',
  ENGLISH: 'English',
  SPA: "SPA",
  DESC_NAME_REQUIRD: 'Description is required',
  MAX_VIDEO_LIMIT_ERROR: 'You can only upload one video at a time.',
  IMAGE_VIDEO_SIZE_ERROR: 'File size exceeds the maximum limit of 25 MB.',
  IMAAGE_VIDEO: 'You can upload a maximum of two files: either one photo and one video or two photos.',
  IMAGE1: "Image 1",
  IMAGE2: "Image 2",
  VALIDIMAGE: "Please upload valid image & video",
  Item: 'Item',
  LOGIN_EMAIL_ADDRESS: "Email Address",
  LOGIN_EMAIL_ADDRESS_TEXT: "Enter email address",
  REMEBER_ME: 'Remember me',
  FORGOT_PASSWORD: "Forgot Password",
  LOGIN_MESSAGE: 'Don’t have an account?',
  SINGUP: 'Sign Up',
  SEND_OTP: 'Send OTP',
  OTP_VERIFICATION: 'OTP Verification',
  ENTER_OTP_DIGIT: 'Enter the 4 digit OTP sent to',
  DONT_RECIVE_CODE: `Didn't receive Code`,
  RESEND_IN: 'Resend in',
  RESEND_OTP: 'Resend OTP',
  VERIFY: 'Verify',
  RESET_PASSWORD: 'Reset password',
  Confirm_Password: 'Confirm Password',
  ENTER_YOUR_DETAILS: 'Enter your details to create your account',
  HAVE_ACCOUNT: 'Already have a account',
  ACCPET: "Accept",
  TERMS_SINGUP: 'Terms',
  Condition: 'Condition',
  PRIVACY_POLICY: 'Privacy Policies',
  GUEST_USER:'Continue as a',
  GUEST:'Guest',
  SINGUP_WITH:'Or Sign Up With',
  LOGIN_WITH:'Or Login With',
  ENTER_YOUR_LOGIN_DETAILS: 'Enter your details to login',
  NEW_REQUEST_QUOTES: "NEW QUOTE REQUEST",
  SELECT_METHOD:'Please select the entry method and continue',
  IAGREEWITH: "I agree with",
  ORDERQUOTATIONID: 'Quote Id',
  BACK:"Back",
  IMPORT:"Import",
  SEEPREVIEW:'See preview',
  NEW_QTY:'New Quantity',
  BY:"By",
  UPDATE:'Update',
  ARE_YOU_SURE_UPDATE:'Are you sure you want to continue without making any other changes ?',
  TRACKING:'Tracking',
  NOTIFACTION_TITAL:'Welcome to Quote & Buy!',
  NOTIFACTION_FIRST_DESC:'We are happy to see you have created an account with us. Here you can request a quote for anything. We will review your request and provide you with a quote as soon as possible.Here are your credentials for your account and remember to keep them at hand.',
  USERNAME:'Username',
  NOTIFACTION_THIRD:'You may continue to request a quote via Manual Entry or Bulk Upload when you are ready.',
  BULK_PERA:"Please download the Excel template, fill in the necessary details, upload it, and submit it to receive a quotation for bulk products.",
  CONFIRMA : 'Confirm',
  MESSAGE_FOR_PRODUCT:'Could you please first confirm if you have made any changes?',
  REFUND:'Refunded',
  BULK_REQUEST_TEXT:'Bulk Request via Excel',
  INCORRECT_TEXT:'The quotation requests for following products are not sent to the admin . You can request quotation for these products by going to the My quotations.',
  INCORRECT_DATA:'Incorrect Data',
  NO_SPACES_ALLOWED: 'Spaces are not allowed or cannot be empty',
  NEW_PENDING :'Quoting',
  NEW_Progress:'Quoted',
  CC:'CC',
  WT:'WT',
  CAETGORY_LIST:'Category Listing',
  CATEGORY_SELECT_ERROR:'Please select at least one category to continue.',
  CATEGORY_SELECT_MESSAGE:'Please select the category that interest you most (one or more)',
  PRIZEMESSAGE:'Following price in USD',
  CATEGORY_SELECTION: "Manage Category",
  SAVE:'Save',
  SURVEY_MESSAGE:"Do you want to participate in a survey?",
  SURVEY:'Survey',
  overall_experience:'Please answer all questions before submitting the survey.',
  GIVE_SURVEY: "Participate in a survey",
  QUESTIONONE:'Q1. How would you rate your shopping experience?',
  QUESTIONTWO:'Q2. How would you rate your experience in the payment process?',
  QUESTIONTHREE:'Q3. The product received corresponds to what you were looking for?',
  QUESTIONFOUR:'Q4. Would you use Quote N Buy to make future purchases?',
  QUESTIONFIVE:'Q5. We Appreciate leaving us a review of your overall purchase experience.?',
  Payment_Cancelled: 'Payment Cancelled',
  Payment_Cancelled1:'You cancelled the payment process.',
  Payment_Cancelled2:'No amount has been deducted from your account.'


}


const SpanishLanguage = {
  Payment_Cancelled2:'No se ha deducido ningún importe de su cuenta.',
  Payment_Cancelled1:'Canceló el proceso de pago.',
  Payment_Cancelled: 'Pago cancelado',
  QUESTIONFIVE:'P5. Agradecemos que nos deje una reseña de su experiencia de compra general.',
  QUESTIONFOUR:'P4. ¿Utilizaría Quote N Buy para realizar compras futuras?',
  QUESTIONTHREE:'P3. ¿El producto recibido corresponde a lo que buscaba?',
  QUESTIONTWO:'P2. ¿Cómo calificarías tu experiencia en el proceso de pago?',
  QUESTIONONE:'P1. ¿Cómo calificarías tu experiencia de compra?',
  GIVE_SURVEY: "Participar en una encuesta",
  overall_experience:'Responda todas las preguntas antes de enviar la encuesta.',
  SURVEY:'Encuesta',
  SURVEY_MESSAGE:"¿Quieres participar en una encuesta?",
  SAVE:'Ahorrar',
  CATEGORY_SELECTION: "Administrar categoría",
  PRIZEMESSAGE:'El siguiente precio está en USD',
  CATEGORY_SELECT_MESSAGE:'Por favor seleccione la categoría que más le interese (una o más)',
  CATEGORY_SELECT_ERROR:'Seleccione al menos una categoría para continuar.',
  HOME:'Hogar',
  CAETGORY_LIST:'Listado de categorías',
  CC:'TC',
  WT:'TB',
  NEW_Progress:'Cotizado',
  NEW_PENDING :'Por Cotizar',
  INCORRECT_DATA:'Datos incorrectos',
  INCORRECT_TEXT:'Las solicitudes de cotización para los siguientes productos no se envían al administrador. Puede solicitar una cotización para estos productos desde Mis cotizaciones.',
  BULK_REQUEST_TEXT:'Solicitud masiva mediante Excel',
  REFUND:'Reintegrada',
  MESSAGE_FOR_PRODUCT:'¿Podrías confirmarme primero si has realizado algún cambio?',
  CONFIRMA : 'Confirmar',
  BULK_PERA:"Descargue la plantilla de Excel, complete los detalles necesarios, cárguela y envíela para recibir una cotización de productos al por mayor.",
  NOTIFACTION_THIRD:'Puede continuar solicitando una cotización mediante Ingreso Manual o Carga Masiva cuando esté listo.',
  USERNAME:'Nombre de Usuario',
  NOTIFACTION_FIRST_DESC:'Nos alegra ver que ha creado una cuenta con nosotros. Aquí puedes solicitar una cotización para cualquier cosa.Revisaremos su solicitud y le proporcionaremos una cotización lo antes posible. Aquí tienes las credenciales de tu cuenta y recuerda tenerlas a mano.',
  NOTIFACTION_TITAL:'¡Bienvenido a Quote & y Buy!',
  TRACKING:'Seguimiento',
  ARE_YOU_SURE_UPDATE:'¿Está seguro que desea continuar sin hacer ningún otro cambio?',
  UPDATE:'Actualizar',
  BY:"Por",
  NEW_QTY:'Nueva cantidad',
  SEEPREVIEW:'Ver Vista previa',
  IMPORT:"Importar",
  BACK:"Atras",
  ORDERQUOTATIONID: 'ID Cot',
  IAGREEWITH: "Estoy de acuerdo con",
  SELECT_METHOD:'Por favor seleccione el método de entrada y continúe',
  NEW_REQUEST_QUOTES: "SOLICITUD DE NUEVA COTIZACIÓN",
  ENTER_YOUR_LOGIN_DETAILS: 'Ingrese sus datos para iniciar sesión',
  LOGIN_WITH:'O Iniciar sesión con',
  SINGUP_WITH:'O regístrate con',
  GUEST_USER:'Continuar como',
  GUEST:'Invitado',
  PRIVACY_POLICY: 'Políticas de Privacidad',
  Condition: 'Condición',
  TERMS_SINGUP: 'Términos',
  ACCPET: "Aceptar",
  HAVE_ACCOUNT: 'Ya tienes una cuenta',
  ENTER_YOUR_DETAILS: 'Ingrese sus datos para crear su cuenta',
  Confirm_Password: 'Confirmar Contraseña',
  RESET_PASSWORD: 'Restablecer contraseña',
  VERIFY: 'Verificar',
  RESEND_OTP: 'Reenviar OTP',
  RESEND_IN: 'Reenviar en',
  DONT_RECIVE_CODE: `No recibí el código`,
  ENTER_OTP_DIGIT: 'Ingrese la OTP de 4 dígitos enviada a',
  OTP_VERIFICATION: 'Verificación OTP',
  SEND_OTP: 'Enviar OTP',
  SINGUP: 'Regístrate',
  LOGIN_MESSAGE: '¿No tienes una cuenta?',
  FORGOT_PASSWORD: "¿Olvidaste tu contraseña",
  REMEBER_ME: 'Recuérdame',
  LOGIN_EMAIL_ADDRESS: "Correo Electrónico",
  LOGIN_EMAIL_ADDRESS_TEXT: "Introduzca la dirección de correo electrónico",
  Item: 'Item',
  EXCLSUBMIT: "Solicitar Cotización",
  VALIDIMAGE: "Por favor, cargue una imagen y un vídeo válidos.",
  IMAGE1: "Imagen 1",
  IMAGE2: "Imagen 2",
  IMAAGE_VIDEO: 'Puedes subir un máximo de dos archivos: una foto y un vídeo o dos fotos.',
  IMAGE_VIDEO_SIZE_ERROR: 'El tamaño del archivo excede el límite máximo de 25 MB.',
  MAX_VIDEO_LIMIT_ERROR: 'Puedes subir solo un video a la vez.',
  DESC_NAME_REQUIRD: 'Se requiere descripción',
  SPA: "ESP",
  ENGLISH: 'English',
  SPANISH: 'Español',
  Charges_reason: 'Razón de los cargos',
  EXTED_PRICE: 'Precio extendido',
  UNIT: 'Unidad',
  Item_Name: 'Nombre del artículo',
  BRAND: 'Marca',
  DAYS: 'DÍAS',
  ORDER_QTY: 'Cantidad',
  LETS_GO: '¡Vamos!',
  DOWNLADAPP: 'Descargar aplicación',
  ENTER_TIME_QUNTITY: 'Por favor ingrese la cantidad',
  ENTER_TIME_QUNTITY_NUMBER: 'Por favor ingrese solo el número',
  HISTORY: 'Historia',
  EXCHANGE: 'Intercambio',
  SEND_UPDATE_REQUEST: 'Enviar cantidad actualizada',
  EDIT_QUANTITY: 'Editar cantidad',
  WRITE: 'Escribir',
  OTHER_BRAND: 'Otra marca',
  VIEW: 'Vista',
  VIEW_ALL: 'Ver todo',
  PRE_PRODUCT_PRICE: 'precio unitario',
  DOWNLOAD_PDF: 'Descargar Pdf',
  UPLOAD: 'Subir archivos',
  PHOTOS_VIDEO: 'Foto o vídeo',
  INSTRUCTIONS: 'Instrucciones de entrega (Opcional)',
  ENTER_INSTRUCTIONS: "Ingrese Los instrucciones para la entrega",
  REQUIRED_LOACTION: 'Por favor seleccione el tipo de ubicación',
  RESIDENTIAL: 'Residencial',
  LABORAL: 'Laboral',
  LOACTION_TYPE: 'Tipo De Domicilio',
  TRAKING_NUMBER: 'El número de rastreo',
  AWB_NUMBER: 'Número AWB',
  WAYBILLNUMBER: 'Número de carta de porte',
  SHIPPINSCompany: 'Compañía naviera',
  TRAKING_URL: 'URL de seguimiento',
  SHPPING_DEATILS: "Detalles de envío",
  CHANGE_ADDRESS_DES: 'Si cambia la dirección, la cotización actual no será válida y la solicitud se enviará nuevamente al administrador.',
  CHANGE_ADDRESS: 'Cambiar dirección',
  VALID_PHONE_NUMBER: "El número de teléfono debe tener al menos 7 números.",
  PHONE_MAX_CHAR: "El número de teléfono no puede exceder los 15 números.",
  PHONE_NUMBER_VALID: "El número de móvil introducido no es válido, inténtalo de nuevo.",
  VALID_PHONE: 'Por favor ingresa un número de teléfono válido',
  EMAIL_ADDRESS: 'Por favor ingrese una dirección de correo electrónico válida.',
  EMAIL_MAX: 'El correo electrónico no puede exceder más de 150 caracteres.',
  EMAIL_MIN: 'El correo electrónico debe tener al menos 3 caracteres.',
  PLEASE_ENTER_Email: 'Por favor ingrese su correo electrónico',
  NAME_MAX: 'El nombre no puede exceder más de 25 caracteres.',
  NAME_MIN: 'El nombre debe tener al menos 3 caracteres.',
  PLEASE_ENTER_NAME: 'Por favor ingresa tu nombre',
  STREET_LINE_OTHER: "La línea de la calle no puede contener espacios consecutivos",
  STREET_LINE_CONTACT_DES_MAX: 'la línea de la calle no puede exceder más de 250 caracteres',
  STREET_LINE_DES_MIN: 'La línea de la calle debe tener al menos 3 caracteres.',
  STREET_LINE: 'Por favor ingrese su línea de calle',
  SELECT_EXCEL: "Por favor seleccione el archivo excel",
  ENTER_PASSWORD: "Por favor ingrese la contraseña",
  Emojis: 'Emojis no permitidas',
  DES_LINE: 'La línea descriptiva no puede contener espacios consecutivos.',
  DES_MIN: 'La descripción debe tener al menos 3 caracteres.',
  CONTACT_DES_MAX: 'La descripción no puede exceder los 250 caracteres.',

  ENTER_DESC: "Por favor ingresa tu descripción",
  PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: "La nueva contraseña y la contraseña de confirmación deben ser Los mismas",
  CONFIRM_PASSWORD_MIN_CHAR: "La contraseña de confirmación debe tener al menos 8 caracteres.",
  CONFIRM_PASSWORD_MAX_CHAR: "Confirmar contraseña no debe exceder los 16 caracteres",
  NEW_PASSWORD_REQUIRED: "Por favor ingrese una nueva contraseña.",
  NEW_PASSWORD_MIN_CHAR: "La nueva contraseña debe tener al menos 8 caracteres.",
  NEW_PASSWORD_MAX_CHAR: "La nueva contraseña no debe exceder los 16 caracteres",

  CONFIRM_NEW_PASSWORD_REQUIRED: "Por favor ingrese confirmar contraseña.",
  CONFIRM_NEW_PASSWORD_MIN_CHAR: "La contraseña para volver a ingresar debe tener al menos 8 caracteres.",
  CONFIRM_NEW_PASSWORD_MAX_CHAR: "Volver a ingresar la contraseña no debe exceder los 16 caracteres.",
  // PASSWORD_CPWD_NOT_MATCHED: "Entered password doesn't match. please try again",
  PASSWORD_CPWD_NOT_MATCHED: "La nueva contraseña y Confirmar contraseña no coinciden.",
  PASSWORD_OLD_NOT_SAME: "Ya has utilizado esta contraseña antes, establece otra contraseña",

  NEW_OLD_PASSWORD_SAME: 'La nueva contraseña no puede ser la misma que la antigua',
  PASSWORD_MATCH: "La contraseña debe tener entre 8 y 15 caracteres y debe contener al menos una mayúscula, una minúscula, un número y un carácter especial.",
  PASSWORD_VALID: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 carácter en mayúscula y 1 carácter especial.",
  PASSWORD_UPPER_CASE: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 carácter en mayúscula y 1 carácter especial.",
  PASSWORD_SPECIAL_CASE: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 mayúscula, 1 minúscula y 1 carácter especial.",
  PASSWORD_NUMBER_CASE: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 carácter en mayúscula y 1 carácter especial.",

  PASSWORD_REQUIRED: "Por favor ingrese la contraseña.",
  CONFIRM_PASSWORD_REQUIRED: "Por favor ingrese confirmar contraseña.",
  NO_SPACE_ALLOWED: "No se permite espacio.",
  OLD_PASSWORD_REQUIRED: "Por favor ingrese la contraseña anterior.",
  OLD_PASSWORD_MIN_CHAR: "La contraseña anterior debe tener al menos 8 caracteres.",
  OLD_PASSWORD_MAX_CHAR: "La contraseña anterior no debe exceder los 16 caracteres.",
  EXCEED: "no puede exceder más de",
  MAX: 'debe ser al menos',
  PLEASE_SELECT: 'Por favor seleccione su',
  PLEASE_ENTER: 'Por favor ingrese su',
  VERFIY_EMAIL: 'Por favor verifique su correo electrónico',
  OTHER_MAX: "El nombre de otra marca no puede exceder los 50 caracteres.",
  OTHER_MIN: "Otra marca mínimo 1 palabra",
  OTHER_BRAND_REQUIRED: "Se requiere otra marca",
  MODAL_MAX: "El número de modelo no puede exceder los 50 caracteres",
  SER_MAX: "El número de serie no puede exceder los 50 caracteres",
  DES_MAX: 'La descripción debe tener como máximo 250 caracteres.',
  QUNTITY_NUMBER: "Por favor ingrese solo el número",
  QUNTITY_MAX: 'La cantidad no puede exceder 1000000',
  QUNTITY_MIN: 'La cantidad debe ser al menos 1',
  QUNITYTY_REQUIRED: "Se requiere cantidad",
  PART_NUMBER_MAX: 'El número de pieza no puede exceder los 50 caracteres',
  PART_NUMBER_MIN: 'El número de pieza debe tener al menos 1 carácter',
  PART_NUMBER_REQUIRED: 'Se requiere el número de pieza',
  BRAND_NAME_REQUIRD: 'Se requiere el nombre de la marca',
  BRAND_NAME_ALREDY: 'El nombre de la marca ya existe.',
  PLEASE_SELECT_SHIPPING_TYPE: 'Por favor seleccione el método de envío',
  PLEASE_SELECR_DELIVER_ADDRESS: 'Por favor seleccione la dirección de entrega',
  PLEASE_SELECT_TYPE: 'Por favor seleccione un tipo',
  CONFIRMA_PASSWORD: 'Confirmar nueva contraseña',
  NEW_PASSWORD: 'Nueva contraseña',
  OLD_PASSOWRD: 'Contraseña anterior',
  ORDER_FILLTER_INPUT: "Buscar por ID de pedido..",
  REJECT_QUTO: "¿Quieres rechazar esta cotización?",
  REQUESTQUOTE: 'Solicitar Cotización',
  CUSTOMER_PURCHASED: "Los clientes también han comprado",
  BRAND_NAME: 'Nombre de la marca',
  MYADDRESS: "Mis direcciones",
  UPDATEADDRES: "ACTUALIZAR DIRECCIÓN",
  OTHER_BRAND_NAME: 'Otra Nombre de la marca',
  YOU_WANT_TO_DELETE: '¿Estás seguro de que quieres eliminar tu cuenta?',
  REMOVE_PRODUCT: 'Eliminar',
  PRODUCT_DELETE_MESSAGE: 'Si elimina los productos, se enviará una solicitud al administrador para su aprobación. El producto sólo se eliminará si el administrador aprueba la solicitud. Si la solicitud es rechazada, el producto permanecerá sin cambios. ¿Aún deseas continuar con la eliminación del producto?',
  DELETE_TITEL: 'Eliminar producto',
  EDIT_Q_MESSAGE: 'Si edita la cantidad, se enviará una solicitud al administrador para su aprobación. Los precios y la cantidad solo se actualizarán si el administrador acepta el cambio. Si se rechaza la solicitud, la cantidad y el precio permanecerán sin cambios. ¿Aún deseas continuar con la edición de la cantidad?',
  Edit_Quantity: 'Editar cantidad',
  REASON: 'Razón',
  ORDER_CANCEL_TITAL: 'Motivo de cancelación del pedido',
  CANCEL: 'Cancelar',
  ORDER_CANCEL_MESSAGE: 'La solicitud se enviará al administrador; si el administrador la aprueba, solo se realizará la cancelación.',
  ORDER_CANCEL: 'Cancelar pedido',
  GO_TO_HOME: 'Ir al Inicio',
  ORDER_LINE_ONE: 'Su pedido ha sido realizado con éxito',
  ORDER_LINE_SEC: 'Su pedido está en proceso, esto no es una factura: Se ha enviado un correo electrónico con la información para realizar el pago mediante transferencia bancaria. Una vez que recibamos los fondos procederemos con su pedido.',

  Successful: 'Exitosa',
  SELETE_PAYMENT_ERROR: 'Por favor seleccione método de pago',
  PLACE_ORDER: 'Proceder con el Pago',
  ONLINE: 'En Línea',
  OFFLIE: 'Transferencia Bancaria',
  PAYMENT_MATHOD: 'Método de pago',
  NET_ORDER_AMOUNT: 'Monto neto del pedido',
  OTHER_CARGERS: 'Otros cargos',
  TOTAL_TAX_AMOUNT: 'Monto total del impuesto',
  EDIT: 'Editar',
  ADDRESS: 'DIRECCIÓN',
  MOBILE: 'Móvil',
  CHECKOUT: 'Verificar',
  PASSWORD: 'Contraseña',
  DELETE_ACCOUNT: 'Eliminar cuenta',
  YES: 'Sí',
  NO: 'No',
  YOU_WANT_TO_LOGUT: '¿Estás seguro de que quieres cerrar sesión?',
  ARE_YOU_SURE: 'Estás Seguro',
  PRICE_BRACKDOWN: 'Desglose de precios',
  PAID: 'Pagado',
  VIEW_HISTORY: 'Ver Historial',
  DATETYPE: "MM/DD/AAAA",
  MESSAGEDATA: 'Buscar por Id. de cita',
  TO: "A",
  FROM: 'De',
  SHIPPING_DETAILS: "Detalles de envío",
  ORIGNAL_REQUEST: 'Solicitud original',
  REVISION: 'Revisión',
  LATEST_REVISION: 'Última revisión',
  PRODUCT_REVISON_HISTORY: "Historial de revisiones del producto",
  PRODUCT_HISTORY: 'Historia del producto',
  Approve: 'Aprobar',
  Reject: 'Rechazar',
  TOTAL_PRODUCT_PRICE: "Precio total del producto",
  TOTAL_SHPPINGH: 'Envío total',
  SHIPPINGPRICE: 'Precio de envío',
  PERPIUCESPRICE: "Precio por pieza",
  SHIPPINGTYPE: "Tipo de envío",
  EDITQUANTITY: 'Confirmar Cambio',
  SEND: 'Enviar',
  MESSAGE: "Mensaje",
  Contact_Us: "Contáctanos",
  ENTER_ZIP_CODE: "Ingrese el código postal",
  ZIP_CODE: "Código postal",
  ENTER_CITY: "Introduce la ciudad",
  CITY: "Ciudad",
  ENTER_STATE: "Ingresar estado",
  STATE: "Estado",
  ENTER_APARTMENT: "Entrar apartamento",
  APRATMENT: "apartamento",
  ENTER_STREE_LINE: "Ingrese la línea de la calle",
  STREE_LINE: "Línea de calle",
  SELETE_ADDRESS: "Seleccionar dirección",
  ENTER_EMAIL_ID: "Ingrese su ID de correo electrónico",
  ENTER_FULL_NAME: "Ingrese el nombre completo",
  UPDATE_PROFILE: "Actualizar perfil",
  PHONE_NUMBER: "Número de teléfono",
  EMAIL_ID: "ID de correo electrónico ",
  NAME: "Nombre",
  MY_PROFILE: "Mi perfil",
  PLEASE_ENTER_QUNTITY: "Por favor ingrese cualquier cantidad de producto",
  MORE: "Más",
  DATANOTFOUND: 'Datos no encontrados',
  ADDMOREPRODUCT: "Agregar otro artículo",
  CHAT: "Charlar",
  NOTIFACTION: "Notificaciones",
  CONVERTINPISO: 'Convertir precio en euros',
  GRANDTOTAL: 'Gran total',
  TOTALTAX: 'Impuesto total',
  TOTALSHIIPNGAMOUNT: 'Precio de envío',
  TOTALPRODUCTAMOUNT: 'Precio total del producto',
  PROVIDEDQUOTATION: 'Detalles de la cotización',
  ORRDERDELIVERYADDRESS: 'Dirección de entrega',
  DELIVERYSTATUS: 'Estado',
  PAYMENTSTATUS: 'Pago',
  ORDERID: 'ID Pedido',
  CANVELLED: 'Cancelada',
  DELIVERD: 'Entregado',
  INTRANSIT: 'En Transito',
  ORDERLIST: 'Lista de pedidos',
  QDATE: 'Fecha de cotización',
  SHIPINNG: 'Método de envío',
  DELADDRESS: 'Dirección de entrega',
  ACTION: "Acción",
  TOTAL: 'Total',
  NET: "Neto",
  TAX: 'Impuesto',
  AMOUNT: "Cantidad",
  CHARGES: 'Cargos',
  OTHER: 'Otros',
  PRICE: 'Precio',
  SHIPPING: 'Envío',
  STATUS: 'Estado',
  DATE: 'Fecha',
  QUOTATIONID: 'ID de cotizacion',
  SNO: 'S. No',
  REJECT: 'Rechazada',
  APPROVED: 'Aprobado',
  Progress: 'En proceso',
  PENDING: 'Pendiente',
  ALL: 'Todo',
  Filter: 'Filtrar',
  Reset: 'Reiniciar',
  QUOTATIONSLIST: 'Cotizaciones',
  PROFILE: 'Perfil',
  MYQUOTATIONS: 'Mis Cotizaciones',
  UploadExcel: 'Subir Excel',
  TEMPLATE: 'Plantilla Excel',
  Download: 'Descargar',
  SUBMIT: "Entregar",
  ADDMORE: 'Agregar nuevo artículo',
  REMOVE: 'Eliminar',
  Photo: 'Foto',
  Video: 'Video',
  TWOBYTWO: 'dos fotos',
  ONEBYONE: 'Una foto y un vídeo',
  UPLOADMEDIA: 'Foto o vídeo',
  MODELNUMBER: ' Modelo',
  SERIALNUMBER: 'Serie N°',
  DESCIPTIONDETAILS: 'Escribe una descripción detallada',
  Description: 'Descripción',
  QUANTITY: 'Cantidad',
  ENTER: 'Ingresar',
  PARTNAME: 'N° Parte',
  SELECTBRAND: 'Seleccionar marca',
  BRANDNAME: "Marca",
  NEXT: "Siguiente",
  NEWADDRES: "AÑADIR NUEVA DIRECCIÓN",
  SHIPPINGMETHOD: 'Seleccione método de envío',
  DELIVERYADDRESS: 'Seleccionar dirección de entrega',
  COUNTINUE: "Continuar",
  EXCEL: 'Carga Masiva',
  BULKREQUEST: "Solicitud masiva a través de",
  QUOTATIONFORM: 'Ingreso Manual',
  REQUESTVIA: 'Solicitar vía',
  PRODUCTLISTING: "Listado de productos",
  CONTACTUS: "Contáctanos",
  PRODUCTSUGGESTIOND: "Sugerencias de productos",
  REQUESTQUOTES: "Solicitar una cotización",
  ABOUTUS: 'Sobre nosotros',
  TESTIMONIAL: "Testimonios",
  CLIENTREVIEW: '¿Qué dicen Los clientes felices de nosotros?',
  PRIACYPOLICY: "Política de Privacidad",
  TERMS: 'Términos y Condiciones',
  COPYRIGHT: "© 2025-2026 Cotizar y Comprar. Reservados todos los derechos.",
  FAQS: "Preguntas frecuentes",
  LOGIN: "Iniciar sesión",
  LOGOUT: "Cerrar sesión",
  VIEWPROFILE: "Ver perfil",
  MYORDER: "Mis Ordenes",
  MYOUESTION: 'Mis cotizaciones',
  SETTING: 'Ajustes',
  CHANGEPASSWORD: "Cambiar la contraseña",
  NOTIFIACTION: 'Configuración de notificación',
  DELETEACCOUNT: "Eliminar cuenta",
  YOU_WANT_TO_DELETE_Address: '¿Está seguro de que desea eliminar su dirección?',
  NO_SPACES_ALLOWED: 'No se permiten espacios o no pueden estar vacíos',
}

const Translate = getFromStorage({ key: StorageConstant?.Translate });


export const LanguageConstants = Translate == "spa"  ? SpanishLanguage : EnglishLanguage